'use client';

import { createContext } from 'react';

import type { PaginationRootContextInterface } from '../types/pagination-root.types';

export const PaginationRootContext = createContext<PaginationRootContextInterface>({
  totalPages: 0,
});

PaginationRootContext.displayName = 'Pagination.Root.Context';
